import React from 'react';

import { StaffingRequestApplicationState } from '@common/graphql';
import { MissionControlStaffingTableCandidatesBase } from './_mission-control-staffing-table-candidates-base';

const OFFERS_PENDING_STATES: StaffingRequestApplicationState[] = ['offered'];

export function MissionControlStaffingTableOffersPending() {
  return (
    <MissionControlStaffingTableCandidatesBase
      tableKind="OffersPending"
      defaultStateFilters={OFFERS_PENDING_STATES}
    />
  );
}
